// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RangeAnalysisTab_container__tsMup {
  padding: 0 1rem 1rem 1rem;
  min-height: 100vh;
}

.RangeAnalysisTab_cardTitle__1\\+Ziq {
  color: #364e69;
  font-weight: bold;
  margin-bottom: 0;
}

.RangeAnalysisTab_performanceToggleBtn__yfEYr {
  border-color: #8cacd4;
  transition: all 0.2s ease;
}

.RangeAnalysisTab_performanceToggleBtn__yfEYr:hover,
.RangeAnalysisTab_performanceToggleBtn__yfEYr:focus,
.RangeAnalysisTab_performanceToggleBtn__yfEYr:active {
  background-color: #8cacd4 !important;
  border-color: #8cacd4 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_performanceToggleBtnActive__mmtZ6 {
  background-color: #8cacd4 !important;
  border-color: #8cacd4 !important;
  color: white !important;
}

.RangeAnalysisTab_performanceToggleBtnActive__mmtZ6:hover,
.RangeAnalysisTab_performanceToggleBtnActive__mmtZ6:focus,
.RangeAnalysisTab_performanceToggleBtnActive__mmtZ6:active {
  background-color: #7a9bc4 !important;
  border-color: #7a9bc4 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_performanceToggleBtnInactive__vuWRt {
  background-color: transparent !important;
  border-color: #8cacd4 !important;
  color: #8cacd4 !important;
}

.RangeAnalysisTab_performanceToggleBtnInactive__vuWRt:hover,
.RangeAnalysisTab_performanceToggleBtnInactive__vuWRt:focus,
.RangeAnalysisTab_performanceToggleBtnInactive__vuWRt:active {
  background-color: #8cacd4 !important;
  border-color: #8cacd4 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_performanceCard__B78xw {
  min-height: auto;
}

.RangeAnalysisTab_performanceCardTitle__lUL6v {
  color: #364e69;
  font-weight: bold;
  margin-bottom: 0.5rem;
  text-transform: none;
  /* Add this line */
}

.RangeAnalysisTab_vehicleRankCard__7CltW {
  background-color: #8cacd4;
  border: 0;
  margin-bottom: 0.5rem;
}

.RangeAnalysisTab_vehicleRankActive__wgGyt {
  background-color: #768fad;
  border: 0;
  margin-bottom: 0.5rem;
}

.RangeAnalysisTab_vehicleRankCardBody__aB3DF {
  padding: 0.5rem 0.75rem;
}

.RangeAnalysisTab_rankBadge__nV0oF {
  background-color: white !important;
  color: #8cacd4 !important;
  width: 30px !important;
  height: 30px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 14px !important;
  font-weight: bold !important;
  flex-shrink: 0 !important;
  border: none !important;
}

.RangeAnalysisTab_vehicleRankText__QUGPN {
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
}

.RangeAnalysisTab_vehicleRankSubtext__eS7Kb {
  color: white;
  font-size: 0.75rem;
}

.RangeAnalysisTab_energyEfficiencyText__t2gkx {
  color: white;
  font-size: 0.85rem;
  font-weight: bold;
}

.RangeAnalysisTab_energyEfficiencySubtext__I-Jq\\+ {
  color: white;
  font-size: 0.7rem;
}

.RangeAnalysisTab_metricsContainer__lmH5U {
  min-width: 180px;
}

.RangeAnalysisTab_mainMetric__gPW\\+r {
  color: #364e69;
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 0;
}

.RangeAnalysisTab_mainMetricSmall__KaZ\\+0 {
  color: #364e69;
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 0;
}

.RangeAnalysisTab_mainMetricLabel__fDEbS {
  color: #364e69;
  font-size: 0.75rem;
}

/* New styles for the metrics card */
.RangeAnalysisTab_metricsCard__Q41nC {
  background-color: #8cacd4;
  border: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.RangeAnalysisTab_metricsCardBody__RXV3C {
  padding: 1rem;
}

.RangeAnalysisTab_performanceIndicatorCard__jrpPt {
  height: 90px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 0;
}

.RangeAnalysisTab_performanceIndicatorCardTransparent__KX3zY {
  height: 90px;
  /* background-color: white; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  /* border: 0; */
}

.RangeAnalysisTab_performanceIndicatorIcon__Fl6LX {
  color: #8cacd4;
  font-size: 1.1rem;
  margin-bottom: 0.25rem;
}

.RangeAnalysisTab_performanceIndicatorTitle__SNU6\\+ {
  font-size: 0.85rem;
  font-weight: 500;
}

.RangeAnalysisTab_performanceIndicatorValue__cJed8 {
  font-size: 0.72rem;
}

.RangeAnalysisTab_tableToggleBtn__Jd7hn {
  border-color: #8cacd4;
  transition: all 0.2s ease;
}

.RangeAnalysisTab_tableToggleBtn__Jd7hn:hover,
.RangeAnalysisTab_tableToggleBtn__Jd7hn:focus,
.RangeAnalysisTab_tableToggleBtn__Jd7hn:active {
  background-color: #8cacd4 !important;
  border-color: #8cacd4 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_tableToggleBtnActive__9sddb {
  background-color: #8cacd4 !important;
  border-color: #8cacd4 !important;
  color: white !important;
}

.RangeAnalysisTab_tableToggleBtnActive__9sddb:hover,
.RangeAnalysisTab_tableToggleBtnActive__9sddb:focus,
.RangeAnalysisTab_tableToggleBtnActive__9sddb:active {
  background-color: #7a9bc4 !important;
  border-color: #7a9bc4 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_tableToggleBtnInactive__LjTFN {
  background-color: transparent !important;
  border-color: #8cacd4 !important;
  color: #8cacd4 !important;
}

.RangeAnalysisTab_tableToggleBtnInactive__LjTFN:hover,
.RangeAnalysisTab_tableToggleBtnInactive__LjTFN:focus,
.RangeAnalysisTab_tableToggleBtnInactive__LjTFN:active {
  background-color: #8cacd4 !important;
  border-color: #8cacd4 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_tableHeader__CoWG8 {
  background-color: #8cacd4;
}

.RangeAnalysisTab_tableHeaderText__2hdSP {
  color: white;
  font-weight: 600;
}

.RangeAnalysisTab_vehicleDetailsText__QTDcP {
  font-weight: 600;
  color: #425872;
}

.RangeAnalysisTab_energyConsumptionText__ZJQme {
  font-weight: 500;
}

.RangeAnalysisTab_energyEfficiencyText__t2gkx {
  font-weight: 500;
}

.RangeAnalysisTab_metricsRow__zuq6B {
  padding: 1rem 0;
}

.RangeAnalysisTab_metricItem__2aS11 {
  text-align: center;
}

.RangeAnalysisTab_metricLabel__2Ij18 {
  color: #364e69;
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.RangeAnalysisTab_metricValue__uYCxc {
  color: #364e69;
  font-size: 1rem;
  font-weight: bold;
}

.RangeAnalysisTab_downloadBtn__SSsfz {
  border: 1px solid #8cacd4 !important;
  color: #8cacd4 !important;
  background-color: transparent !important;
  transition: all 0.2s ease;
}

.RangeAnalysisTab_downloadBtn__SSsfz:hover,
.RangeAnalysisTab_downloadBtn__SSsfz:focus,
.RangeAnalysisTab_downloadBtn__SSsfz:active {
  background-color: #8cacd4 !important;
  border-color: #8cacd4 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Add this new class for smaller metric values */
.RangeAnalysisTab_metricValueSmall__DfLlv {
  color: #364e69;
  font-size: 0.75rem;
  font-weight: bold;
}

/* Styles for rows with dropdown arrows */
.RangeAnalysisTab_tableRowWithDropdown__zEUmg {
  cursor: pointer;
}

.RangeAnalysisTab_dropdownArrow__yOjoI {
  position: absolute;
  right: 15px;
  top: 30%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.RangeAnalysisTab_tableRowWithDropdown__zEUmg:hover .RangeAnalysisTab_dropdownArrow__yOjoI {
  opacity: 0.7;
}

.RangeAnalysisTab_tableCards__KQ3KR {
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.RangeAnalysisTab_tableCardBorder__RUFQK {

  background-color: #f1f5f9;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  text-align: 'center'

}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/RangeAnalysisTab_bus/RangeAnalysisTab.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB;;AAEF","sourcesContent":[".container {\n  padding: 0 1rem 1rem 1rem;\n  min-height: 100vh;\n}\n\n.cardTitle {\n  color: #364e69;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.performanceToggleBtn {\n  border-color: #8cacd4;\n  transition: all 0.2s ease;\n}\n\n.performanceToggleBtn:hover,\n.performanceToggleBtn:focus,\n.performanceToggleBtn:active {\n  background-color: #8cacd4 !important;\n  border-color: #8cacd4 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.performanceToggleBtnActive {\n  background-color: #8cacd4 !important;\n  border-color: #8cacd4 !important;\n  color: white !important;\n}\n\n.performanceToggleBtnActive:hover,\n.performanceToggleBtnActive:focus,\n.performanceToggleBtnActive:active {\n  background-color: #7a9bc4 !important;\n  border-color: #7a9bc4 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.performanceToggleBtnInactive {\n  background-color: transparent !important;\n  border-color: #8cacd4 !important;\n  color: #8cacd4 !important;\n}\n\n.performanceToggleBtnInactive:hover,\n.performanceToggleBtnInactive:focus,\n.performanceToggleBtnInactive:active {\n  background-color: #8cacd4 !important;\n  border-color: #8cacd4 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.performanceCard {\n  min-height: auto;\n}\n\n.performanceCardTitle {\n  color: #364e69;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n  text-transform: none;\n  /* Add this line */\n}\n\n.vehicleRankCard {\n  background-color: #8cacd4;\n  border: 0;\n  margin-bottom: 0.5rem;\n}\n\n.vehicleRankActive {\n  background-color: #768fad;\n  border: 0;\n  margin-bottom: 0.5rem;\n}\n\n.vehicleRankCardBody {\n  padding: 0.5rem 0.75rem;\n}\n\n.rankBadge {\n  background-color: white !important;\n  color: #8cacd4 !important;\n  width: 30px !important;\n  height: 30px !important;\n  border-radius: 50% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-size: 14px !important;\n  font-weight: bold !important;\n  flex-shrink: 0 !important;\n  border: none !important;\n}\n\n.vehicleRankText {\n  color: white;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.vehicleRankSubtext {\n  color: white;\n  font-size: 0.75rem;\n}\n\n.energyEfficiencyText {\n  color: white;\n  font-size: 0.85rem;\n  font-weight: bold;\n}\n\n.energyEfficiencySubtext {\n  color: white;\n  font-size: 0.7rem;\n}\n\n.metricsContainer {\n  min-width: 180px;\n}\n\n.mainMetric {\n  color: #364e69;\n  font-size: 1.8rem;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.mainMetricSmall {\n  color: #364e69;\n  font-size: 1.4rem;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.mainMetricLabel {\n  color: #364e69;\n  font-size: 0.75rem;\n}\n\n/* New styles for the metrics card */\n.metricsCard {\n  background-color: #8cacd4;\n  border: 0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.metricsCardBody {\n  padding: 1rem;\n}\n\n.performanceIndicatorCard {\n  height: 90px;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 0;\n}\n\n.performanceIndicatorCardTransparent {\n  height: 90px;\n  /* background-color: white; */\n  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */\n  /* border: 0; */\n}\n\n.performanceIndicatorIcon {\n  color: #8cacd4;\n  font-size: 1.1rem;\n  margin-bottom: 0.25rem;\n}\n\n.performanceIndicatorTitle {\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.performanceIndicatorValue {\n  font-size: 0.72rem;\n}\n\n.tableToggleBtn {\n  border-color: #8cacd4;\n  transition: all 0.2s ease;\n}\n\n.tableToggleBtn:hover,\n.tableToggleBtn:focus,\n.tableToggleBtn:active {\n  background-color: #8cacd4 !important;\n  border-color: #8cacd4 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.tableToggleBtnActive {\n  background-color: #8cacd4 !important;\n  border-color: #8cacd4 !important;\n  color: white !important;\n}\n\n.tableToggleBtnActive:hover,\n.tableToggleBtnActive:focus,\n.tableToggleBtnActive:active {\n  background-color: #7a9bc4 !important;\n  border-color: #7a9bc4 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.tableToggleBtnInactive {\n  background-color: transparent !important;\n  border-color: #8cacd4 !important;\n  color: #8cacd4 !important;\n}\n\n.tableToggleBtnInactive:hover,\n.tableToggleBtnInactive:focus,\n.tableToggleBtnInactive:active {\n  background-color: #8cacd4 !important;\n  border-color: #8cacd4 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.tableHeader {\n  background-color: #8cacd4;\n}\n\n.tableHeaderText {\n  color: white;\n  font-weight: 600;\n}\n\n.vehicleDetailsText {\n  font-weight: 600;\n  color: #425872;\n}\n\n.energyConsumptionText {\n  font-weight: 500;\n}\n\n.energyEfficiencyText {\n  font-weight: 500;\n}\n\n.metricsRow {\n  padding: 1rem 0;\n}\n\n.metricItem {\n  text-align: center;\n}\n\n.metricLabel {\n  color: #364e69;\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin-bottom: 0.25rem;\n}\n\n.metricValue {\n  color: #364e69;\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.downloadBtn {\n  border: 1px solid #8cacd4 !important;\n  color: #8cacd4 !important;\n  background-color: transparent !important;\n  transition: all 0.2s ease;\n}\n\n.downloadBtn:hover,\n.downloadBtn:focus,\n.downloadBtn:active {\n  background-color: #8cacd4 !important;\n  border-color: #8cacd4 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n/* Add this new class for smaller metric values */\n.metricValueSmall {\n  color: #364e69;\n  font-size: 0.75rem;\n  font-weight: bold;\n}\n\n/* Styles for rows with dropdown arrows */\n.tableRowWithDropdown {\n  cursor: pointer;\n}\n\n.dropdownArrow {\n  position: absolute;\n  right: 15px;\n  top: 30%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tableRowWithDropdown:hover .dropdownArrow {\n  opacity: 0.7;\n}\n\n.tableCards {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.tableCardBorder {\n\n  background-color: #f1f5f9;\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  text-align: 'center'\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RangeAnalysisTab_container__tsMup`,
	"cardTitle": `RangeAnalysisTab_cardTitle__1+Ziq`,
	"performanceToggleBtn": `RangeAnalysisTab_performanceToggleBtn__yfEYr`,
	"performanceToggleBtnActive": `RangeAnalysisTab_performanceToggleBtnActive__mmtZ6`,
	"performanceToggleBtnInactive": `RangeAnalysisTab_performanceToggleBtnInactive__vuWRt`,
	"performanceCard": `RangeAnalysisTab_performanceCard__B78xw`,
	"performanceCardTitle": `RangeAnalysisTab_performanceCardTitle__lUL6v`,
	"vehicleRankCard": `RangeAnalysisTab_vehicleRankCard__7CltW`,
	"vehicleRankActive": `RangeAnalysisTab_vehicleRankActive__wgGyt`,
	"vehicleRankCardBody": `RangeAnalysisTab_vehicleRankCardBody__aB3DF`,
	"rankBadge": `RangeAnalysisTab_rankBadge__nV0oF`,
	"vehicleRankText": `RangeAnalysisTab_vehicleRankText__QUGPN`,
	"vehicleRankSubtext": `RangeAnalysisTab_vehicleRankSubtext__eS7Kb`,
	"energyEfficiencyText": `RangeAnalysisTab_energyEfficiencyText__t2gkx`,
	"energyEfficiencySubtext": `RangeAnalysisTab_energyEfficiencySubtext__I-Jq+`,
	"metricsContainer": `RangeAnalysisTab_metricsContainer__lmH5U`,
	"mainMetric": `RangeAnalysisTab_mainMetric__gPW+r`,
	"mainMetricSmall": `RangeAnalysisTab_mainMetricSmall__KaZ+0`,
	"mainMetricLabel": `RangeAnalysisTab_mainMetricLabel__fDEbS`,
	"metricsCard": `RangeAnalysisTab_metricsCard__Q41nC`,
	"metricsCardBody": `RangeAnalysisTab_metricsCardBody__RXV3C`,
	"performanceIndicatorCard": `RangeAnalysisTab_performanceIndicatorCard__jrpPt`,
	"performanceIndicatorCardTransparent": `RangeAnalysisTab_performanceIndicatorCardTransparent__KX3zY`,
	"performanceIndicatorIcon": `RangeAnalysisTab_performanceIndicatorIcon__Fl6LX`,
	"performanceIndicatorTitle": `RangeAnalysisTab_performanceIndicatorTitle__SNU6+`,
	"performanceIndicatorValue": `RangeAnalysisTab_performanceIndicatorValue__cJed8`,
	"tableToggleBtn": `RangeAnalysisTab_tableToggleBtn__Jd7hn`,
	"tableToggleBtnActive": `RangeAnalysisTab_tableToggleBtnActive__9sddb`,
	"tableToggleBtnInactive": `RangeAnalysisTab_tableToggleBtnInactive__LjTFN`,
	"tableHeader": `RangeAnalysisTab_tableHeader__CoWG8`,
	"tableHeaderText": `RangeAnalysisTab_tableHeaderText__2hdSP`,
	"vehicleDetailsText": `RangeAnalysisTab_vehicleDetailsText__QTDcP`,
	"energyConsumptionText": `RangeAnalysisTab_energyConsumptionText__ZJQme`,
	"metricsRow": `RangeAnalysisTab_metricsRow__zuq6B`,
	"metricItem": `RangeAnalysisTab_metricItem__2aS11`,
	"metricLabel": `RangeAnalysisTab_metricLabel__2Ij18`,
	"metricValue": `RangeAnalysisTab_metricValue__uYCxc`,
	"downloadBtn": `RangeAnalysisTab_downloadBtn__SSsfz`,
	"metricValueSmall": `RangeAnalysisTab_metricValueSmall__DfLlv`,
	"tableRowWithDropdown": `RangeAnalysisTab_tableRowWithDropdown__zEUmg`,
	"dropdownArrow": `RangeAnalysisTab_dropdownArrow__yOjoI`,
	"tableCards": `RangeAnalysisTab_tableCards__KQ3KR`,
	"tableCardBorder": `RangeAnalysisTab_tableCardBorder__RUFQK`
};
export default ___CSS_LOADER_EXPORT___;
